<template>
<div>
    <b-modal id="matterProfessionalInvestigationFormModal" ref="matterProfessionalInvestigationFormModal" centered size="customize" no-close-on-backdrop :title="$t('matter.matter_professional_investigation')" :cancel-title="$t('others.cancel_title')" :ok-title="$t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate()" @hidden="resetForm()">
        <b-card>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterProfessionalInvestigation.type') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawProfessionalInvestigationTypeSelect" value-field="id" text-field="name" :options="lawProfessionalInvestigationTypeOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterProfessionalInvestigation.region') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawProfessionalInvestigationRegionSelect" value-field="id" text-field="name" :options="lawProfessionalInvestigationRegionOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterProfessionalInvestigation.city') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="citySelect" value-field="id" text-field="name" :options="cityOption" @change="getDistrictList()" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterProfessionalInvestigation.state') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="districtSelect" value-field="id" text-field="name" :options="districtOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterProfessionalInvestigation.product_location') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawProductLocationSelect" value-field="id" text-field="name" :options="lawProductLocationOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterProfessionalInvestigation.stock_delivery_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="stockDeliveryDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterProfessionalInvestigation.report_receipt_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="reportReceiptDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterProfessionalInvestigation.instruction_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="instructionDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            lawProfessionalInvestigationTypeSelect: 0,
            lawProfessionalInvestigationTypeOption: [],
            instructionDate: null,
            citySelect: 0,
            cityOption: [],
            districtSelect: 0,
            districtOption: [],
            districtList: null,
            reportReceiptDate: null,
            stockDeliveryDate: null,
            lawProductLocationSelect: 0,
            lawProductLocationOption: [],
            lawProfessionalInvestigationRegionSelect: 0,
            lawProfessionalInvestigationRegionOption: [],
        }
    },
    methods: {
        resetForm() {
            this.id = 0
            this.lawMatterId = 0
            this.lawProfessionalInvestigationTypeSelect = 0
            this.instructionDate = null
            this.citySelect = 0
            this.districtSelect = 0
            this.districtOption = []
            this.reportReceiptDate = null
            this.stockDeliveryDate = null
            this.lawProductLocationSelect = 0
            this.lawProfessionalInvestigationRegionSelect = 0
        },
        showProfessionalInvestigation(id, lawMatterId) {
            this.$refs['matterProfessionalInvestigationFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterProfessionalInvestigation'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.lawProfessionalInvestigationTypeOption = response.data.lawProfessionalInvestigationTypeList
                    if (this.lawProfessionalInvestigationTypeOption != null) {
                        this.lawProfessionalInvestigationTypeOption.splice(0, 0, this.$nullSelected())
                    }

                    this.cityOption = response.data.cityList
                    if (this.cityOption != null) {
                        this.cityOption.splice(0, 0, this.$nullSelected())
                    }
                    this.districtList = response.data.districtList

                    this.lawProductLocationOption = response.data.lawProductLocationList
                    if (this.lawProductLocationOption != null) {
                        this.lawProductLocationOption.splice(0, 0, this.$nullSelected())
                    }

                    this.lawProfessionalInvestigationRegionOption = response.data.lawProfessionalInvestigationRegionList
                    if (this.lawProfessionalInvestigationRegionOption != null) {
                        this.lawProfessionalInvestigationRegionOption.splice(0, 0, this.$nullSelected())
                    }

                    this.lawProfessionalInvestigationTypeSelect = response.data.lawMatterProfessionalInvestigation.lawProfessionalInvestigationTypeId
                    this.instructionDate = response.data.lawMatterProfessionalInvestigation.instructionDate
                    this.reportReceiptDate = response.data.lawMatterProfessionalInvestigation.reportReceiptDate
                    this.stockDeliveryDate = response.data.lawMatterProfessionalInvestigation.stockDeliveryDate
                    this.lawProductLocationSelect = response.data.lawMatterProfessionalInvestigation.lawProductLocationId
                    this.lawProfessionalInvestigationRegionSelect = response.data.lawMatterProfessionalInvestigation.lawProfessionalInvestigationRegionId
                    this.citySelect = response.data.lawMatterProfessionalInvestigation.cityId

                    if (response.data.lawMatterProfessionalInvestigation.cityId != 0) {
                        this.districtOption = this.districtList.filter(p => p.cityId == response.data.lawMatterProfessionalInvestigation.cityId)
                        this.districtSelect = response.data.lawMatterProfessionalInvestigation.districtId
                        this.districtOption.splice(0, 0, this.$nullSelected())
                    }
                } else {
                    this.$bvModal.hide('matterProfessionalInvestigationFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async addOrUpdate() {
            const lawMatterProfessionalInvestigationData = {
                id: this.id,
                lawMatterId: this.lawMatterId,
                lawProfessionalInvestigationTypeId: this.lawProfessionalInvestigationTypeSelect,
                instructionDate: this.instructionDate,
                cityId: this.citySelect,
                districtId: this.districtSelect,
                reportReceiptDate: this.reportReceiptDate,
                stockDeliveryDate: this.stockDeliveryDate,
                lawProductLocationId: this.lawProductLocationSelect,
                lawProfessionalInvestigationRegionId: this.lawProfessionalInvestigationRegionSelect,
            }
            const controller = {
                name: 'LawMatterProfessionalInvestigation'
            }
            const payload = {
                data: lawMatterProfessionalInvestigationData,
                controller: controller
            }
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if (!this.id) {
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(19, this.id, this.lawMatterId, this.employeeId)
                    this.getMatterTypeHistoryList()
                }
                this.$SaveAlert()
                this.$bvModal.hide('matterProfessionalInvestigationFormModal')
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
        getDistrictList() {
            if (this.citySelect > 0) {
                this.districtOption = this.districtList.filter(p => p.cityId == this.citySelect)
                this.districtSelect = 0
                this.districtOption.splice(0, 0, this.$nullSelected())
            }
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
@media (min-width: 992px) { .modal .modal-customize { max-width: 60% !important; width: 60% !important; } }
</style>
